import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchCommerceLink } from 'redux/commerce/actions';

import { Dropdown } from 'semantic-ui-react';

import './CommercePaymentProviderDropdown.css';

function CommercePaymentProviderDropdown(props) {
  const { me, linkItem, patchCommerceLink } = props;

  const providersOptions = me.payment_provider && me.payment_provider.length > 0 ?
    me.payment_provider.filter(item => item.charges_enabled === true).map(i => ({
      key: `payment-provider-id-${i.id}`,
      text: i.provider_title,
      value: i.id,
    })) : [];

  return (
    <div className="commerce-payment-provider-dropdown__component">
      <div className="label">Payment Provider</div>
      {!linkItem.payment_provider &&
        <div className="undertext">
          Please select your payment provider to activate commerce link
        </div>
      }
      <Dropdown
        fluid
        search
        selection
        value={linkItem.payment_provider}
        options={providersOptions}
        onChange={(_e, data) => {
          patchCommerceLink(linkItem.id, { payment_provider: data.value });
        }}
      />
    </div>
  );
}

CommercePaymentProviderDropdown.propTypes = {
  patchCommerceLink: PropTypes.func.isRequired,
  me: PropTypes.object,
  linkItem: PropTypes.object.isRequired,
};

CommercePaymentProviderDropdown.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCommerceLink,
  },
)(CommercePaymentProviderDropdown);
